import React from 'react';
import { Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { SvgIcon } from '../../common';
import './StatsWidget.scss';

const StatsWidget = ({title, tooltip, statsnumbers, statspercents, url, extenalurl, className}) => {
    return (
        <>
            {url ? 
                <Link to={url} className={`${"statswidget-card"} ${className}`}>
                    <div className="statswidget-card-inner">
                        <div className="statswidget-title"> 
                            {title}
                            {tooltip && (
                                <Tooltip title={tooltip}>
                                    <SvgIcon name="info" viewbox="0 0 13.75 13.75" />
                                </Tooltip>
                            )}
                        </div>
                        {statsnumbers && (
                            <div className="statswidget-number">
                                <h3>{statsnumbers}</h3>
                            </div>
                        )}
                        <div className="statswidget-percents">
                            <div>{statspercents && `+ ${statspercents}`}</div>
                            <div><SvgIcon name="arrow-right" viewbox="0 0 12 8" /></div>
                        </div>
                    </div>
                </Link>
                :
                (extenalurl ?
                    <div onClick={()=> window.open(`${extenalurl}`, '_blank')} className={`${"statswidget-card link-tag"} ${className}`}>
                        <div className="statswidget-card-inner">
                            <div className="statswidget-title"> 
                                {title}
                                {tooltip && (
                                    <Tooltip title={tooltip}>
                                        <SvgIcon name="info" viewbox="0 0 13.75 13.75" />
                                    </Tooltip>
                                )}
                            </div>
                            {statsnumbers && (
                                <div className="statswidget-number">
                                    <h3>{statsnumbers}</h3>
                                </div>
                            )}
                            <div className="statswidget-percents">
                                <div>{statspercents && `+ ${statspercents}`}</div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={`${"statswidget-card"} ${className}`}>
                        <div className="statswidget-card-inner">
                            <div className="statswidget-title"> 
                                {title}
                                {tooltip && (
                                    <Tooltip title={tooltip}>
                                        <SvgIcon name="info" viewbox="0 0 13.75 13.75" />
                                    </Tooltip>
                                )}
                            </div>
                            {statsnumbers && (
                                <div className="statswidget-number">
                                    <h3>{statsnumbers}</h3>
                                </div>
                            )}
                            <div className="statswidget-percents">
                                <div>{statspercents && `+ ${statspercents}`}</div>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    )
}

export default StatsWidget
